import { Text, Card, CardColors } from '@/ui'
import { BalanceSheetReportData } from '@/actions/reportActions'
import { formatCurrencyFromCentsAndRound } from '@/utils/currencyHelpers'
import { BalanceSheetCategory } from './BalanceSheetCategory'
import { TypographyStyles } from '@/styles'

interface BalanceSheetReportProps {
  balanceSheetDate: string
  reportData: BalanceSheetReportData
  isPdf?: boolean
}

export const BalanceSheetReport = ({
  balanceSheetDate,
  reportData,
  isPdf = false,
}: BalanceSheetReportProps) => {
  return (
    <div className="w-11/12 mx-auto">
      {/* Header */}
      <div className="flex justify-center">
        <Text variant={TypographyStyles.H2} className="text-center">
          Balance Sheet
        </Text>
      </div>
      <div className="flex justify-center">
        <Text variant={TypographyStyles.BODY_MD} className="text-center">
          As of {balanceSheetDate}
        </Text>
      </div>

      {/* Table / Report */}
      <div className="flex">
        <div className="flex-1">
          <Text variant={TypographyStyles.H2}>Assets</Text>
        </div>
        <div className="flex-1">
          <Text variant={TypographyStyles.H2}>Liabilities</Text>
        </div>
      </div>
      <div className="flex">
        <div className="flex-1">
          <BalanceSheetCategory
            categoryData={reportData.accounts.Assets}
            totalLabel="Total Assets"
            isPdf={isPdf}
            balanceSheetDate={balanceSheetDate}
          />
        </div>
        <div className="flex-1">
          <BalanceSheetCategory
            categoryData={reportData.accounts.Liability}
            totalLabel="Total Liabilities"
            isPdf={isPdf}
            balanceSheetDate={balanceSheetDate}
          />
          <Text variant={TypographyStyles.H2} className="mt-12 mb-6">
            Equity
          </Text>
          <BalanceSheetCategory
            categoryData={reportData.accounts.Equity}
            totalLabel="Total Equity"
            isPdf={isPdf}
            balanceSheetDate={balanceSheetDate}
          />
        </div>
      </div>

      <Card color={CardColors.PRIORITY}>
        <div className="flex">
          <div className="w-7/12">
            <div className="flex justify-between">
              <Text variant={TypographyStyles.H3}>
                {formatCurrencyFromCentsAndRound(
                  reportData.totals.totalAssetsInCents,
                  { hideDecimalsIfZero: true }
                )}
              </Text>
              <Text variant={TypographyStyles.H3}>Total Assets</Text>
            </div>
          </div>
          <div className="w-2/12 flex justify-center">
            <Text variant={TypographyStyles.H3}>=</Text>
          </div>
          <div className="w-7/12">
            <div className="flex justify-between">
              <Text variant={TypographyStyles.H3}>
                {formatCurrencyFromCentsAndRound(
                  reportData.totals.totalLiabilitiesEquityInCents,
                  { hideDecimalsIfZero: true }
                )}
              </Text>
              <Text variant={TypographyStyles.H3}>
                Total Liabilities & Equities
              </Text>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
